import { StyleSheet } from 'react-native'

import { MotiView } from '@zet/common/components/motiView'
import { Stack, XStack, colors } from '@zet/design-system'
import { Skeleton } from 'moti/skeleton'

import { Spacer } from './spacer'

const BrandEligible = () => {
  return (
    <MotiView
      transition={{
        type: 'timing',
      }}
      style={[styles.container, styles.padded]}
      animate={{ backgroundColor: colors.neutral.white100 }}
    >
      <XStack className="items-center justify-between pr-3">
        <Stack>
          <Skeleton colorMode={'light'} width={260} height={16} />
          <Spacer height={4} />
          <Skeleton colorMode={'light'} width={260} height={12} />
        </Stack>
        <Skeleton colorMode={'light'} width={30} />
      </XStack>
      <Spacer height={8} />
      <Skeleton colorMode={'light'} width={'100%'} height={16} />
      <Spacer height={8} />
      <Skeleton colorMode={'light'} width={'100%'} />
      <Spacer height={8} />
      <Skeleton colorMode={'light'} width={'100%'} height={44} />
    </MotiView>
  )
}

export default BrandEligible

const styles = StyleSheet.create({
  shape: {
    justifyContent: 'center',
    height: 250,
    width: 250,
    borderRadius: 25,
    marginRight: 10,
    backgroundColor: 'white',
  },
  container: {
    justifyContent: 'center',
  },
  padded: {
    padding: 16,
  },
})
